import { TXTWCL_Must_not_start_or_end_with_a_s_ELL } from '../translations';
import type { Error } from '../types';
import { WHITE_START_OR_END_REGEXP } from '../utils/regex';

export const noWhiteStartOrEnd = (value: string): Error => ({
  valid: !WHITE_START_OR_END_REGEXP.test(value),
  message: TXTWCL_Must_not_start_or_end_with_a_s_ELL
});
